export default {
    sendPv(pageId, pageName) {
        if (!window.zwlogger) {
            // console.log('sendPv will retry after init')
            setTimeout(() => {
                this.sendPv(pageId, pageName)
            }, 1000)
            return
        }
        try {
            const cost = Math.floor(Math.random() * 50) + 1;
            window.zwlogger.sendPV({
                miniAppId: '2002389977',
                miniappid: '2002389977',
                miniAppName: '杭州市消防救援便民服务平台',
                miniappname: '杭州市消防救援便民服务平台',
                t2: `${cost}`,
                t0: `${cost}`,
                log_status: '02',
                pageid: pageId,
                pageId: pageId,
                pagename: pageName ? pageName : 'View' + pageId,
                pageName: pageName ? pageName : 'View' + pageId,
            });
            window.zwlogger.record(pageId, 'CLK', {
                page_name: pageName
            })
        } catch (e) {
            console.log('send pv fail', pageId, pageName, e)
        }
    },
    setUserInfo(userinfo) {
        if (userinfo) {
            localStorage.setItem('_zw_log_init_info', JSON.stringify(userinfo))
        }
    }
}